import { ApiError, BrowseViewResponseDto, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { ClientProduct } from '../types';

export const getClientProduct = async (
  id: string,
  {
    page,
    pageSize,
    search,
  }: {
    page: number;
    pageSize: number;
    search: string;
  }
): Promise<BrowseViewResponseDto<ClientProduct>> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/client-work-order/${id}/products?${new URLSearchParams(
      {
        page: page.toString(),
        pageSize: pageSize.toString(),
        search: search.toString(),
      }
    )}`,
    {
      method: 'GET',
      headers: {
        authenticate: `${localStorage.getItem('accessToken')}` || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<ClientProduct>;
  return response;
};
